import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalHomePerformanceQuery = graphql(/* GraphQL */ `
  query ClientPortalHomePerformance($portfolioId: ID, $householdId: ID) {
    clientPortalAllocationSortByRatio(householdId: $householdId)
    portfolioPerformanceReport(portfolioId: $portfolioId, householdId: $householdId) {
      id
      dataLastUpdated
      performanceOverTime {
        timePeriod
        twr
        usdReturn
        startDate
        endDate
      }
      portfolioGraphValues {
        date
        valueUsd
        netInvestedUsd
        includeInAllTime
      }
      holdings {
        assetCategory
        assetClass
        value {
          amount
        }
      }
    }
  }
`);

export type ClientPortalHomePerformanceResult = ResultOf<typeof ClientPortalHomePerformanceQuery>;

export type ClientPortalHomePerformanceReport = ClientPortalHomePerformanceResult['portfolioPerformanceReport'];

export type ClientPortalHomePerformancePeriod = ClientPortalHomePerformanceReport['performanceOverTime'][number];
